import { JobAdminUpdateBody } from "../../../../page-controller-mod/page-serv/settings/application-set/ts/setting-applicaation.type";
import { SettingChange } from "./settings-draft.context";

export const buildJobAdminPayload = (changes: SettingChange[]): JobAdminUpdateBody => { //NOSONAR
  const body: JobAdminUpdateBody = {};

  const ensure = {
    post: () => (body.post ??= {}),
    code: () => (body.code ??= {}),
  };

  for (const c of changes) { //NOSONAR
    if (c.pageKey !== "application") continue; //NOSONAR

    // TOGGLES
    if (c.type === "toggle") { //NOSONAR
      const v = Boolean(c.value);

      if (c.groupId === 1 && c.itemId === 1) ensure.post().requireApproval = v; //NOSONAR
      if (c.groupId === 1 && c.itemId === 2) ensure.post().autoUnpublishOnExpiry = v; //NOSONAR

      continue;
    }

    // INPUTS
    if (c.type === "input") { //NOSONAR
      // (1,3) defaultExpiryDays
      if (c.groupId === 1 && c.itemId === 3) {
        const n = Number(String(c.value).trim());
        if (!Number.isFinite(n)) continue; //NOSONAR
        ensure.post().defaultExpiryDays = n;
        continue;
      }

      // (1,4) code.format -> API expects stringified JSON
      if (c.groupId === 1 && c.itemId === 4) { //NOSONAR
        const fmt = String(c.value ?? /* istanbul ignore next */ "").trim();
        if (!fmt) continue; //NOSONAR

        ensure.code().format = JSON.stringify({ format: fmt });
        continue;
      }
    }
  }

  return body;
};